// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZaoB5","list":"styles_list__X5pmW","textContent":"styles_textContent__pdzMK","add":"styles_add__ahSwq"};